import React from 'react'
import Container from '@mui/material/Container';
import { Box } from '@mui/system';
import { Button } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Axois from 'axios';
import { useEffect, useState } from 'react';

function createData(Lizenznummer, Vorname, Nachname, Mail) {
  return { Lizenznummer, Vorname, Nachname, Mail };
}

const rows = [
  createData(158512, 'Livio', 'Kneubühler', 'kneub.livio@gmail.com'),
  createData(158512, 'Livio', 'Kneubühler', 'kneub.livio@gmail.com'),
  createData(158512, 'Livio', 'Kneubühler', 'kneub.livio@gmail.com'),
  createData(158512, 'Livio', 'Kneubühler', 'kneub.livio@gmail.com'),
  createData(158512, 'Livio', 'Kneubühler', 'kneub.livio@gmail.com'),
];

function UserManagement() {

  const [userData, setUserData] = useState([]);

    useEffect(() => {

      Axois.post(process.env.REACT_APP_BACKEND_URL + 'getusers', {
        
      }, 
      {
          headers: {
            "x-access-token": localStorage.getItem("token"),
          },
      }).then((response) => {
          setUserData(response.data)
      });
  }, []);



  return (
    <Container width="100%">
        <h1>Benutzerverwaltung</h1>
        <Box >
          <Button variant="contained" size="medium">
            Benutzer Hinzufügen
          </Button>
        </Box>
        <Box sx={{
          paddingTop: 5,
        }}>

        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell>Lizenznummer</TableCell>
                  <TableCell>Vorname</TableCell>
                  <TableCell>Nachname</TableCell>
                  <TableCell>E-Mail Adresse</TableCell>
                  <TableCell>Benutzer anpassen</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {userData.map((user) => (
                  <TableRow
                    key={user.UserID}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {user.UserID}
                    </TableCell>
                    <TableCell>{user.Vorname}</TableCell>
                    <TableCell>{user.Nachname}</TableCell>
                    <TableCell>{user.E_Mail_Adress}</TableCell>
                    <TableCell>
                      <Button variant="text" size="medium">
                        ändern
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

        </Box>
    </Container>
  )
}

export default UserManagement